import type {
  ParamsGetMerchflowsReviews,
  ResponseGetMerchflowsReviews,
} from "@CommonApi/merchflows/reviews";
import { RouteGetMerchflowsReviews } from "@CommonApi/merchflows/reviews";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { normalizeMerchflowsReviewsQueryParams } from "./reviewsQueryParams";
import { repeatedBareArrayParamsSerializer } from "src/api/queryParams";
import { API, getRequest } from "src/utils/axios";

export const MERCHFLOWS_REVIEWS_QUERY_KEY = ["merchflows", "reviews"];

export const merchflowsReviewsQueryKey = (queryParams: ParamsGetMerchflowsReviews) => [
  ...MERCHFLOWS_REVIEWS_QUERY_KEY,
  queryParams,
];

export const fetchMerchflowsReviews = async (
  queryParams: ParamsGetMerchflowsReviews,
  signal?: AbortSignal,
): Promise<ResponseGetMerchflowsReviews> => {
  const { data } = await getRequest<ResponseGetMerchflowsReviews>(
    `${API}${RouteGetMerchflowsReviews}`,
    {
      queryParams: normalizeMerchflowsReviewsQueryParams(queryParams),
      paramsSerializer: repeatedBareArrayParamsSerializer,
      signal,
    },
  );

  return data;
};

export const useMerchflowsReviewsQuery = (queryParams: ParamsGetMerchflowsReviews) =>
  useQuery({
    queryKey: merchflowsReviewsQueryKey(queryParams),
    queryFn: ({ signal }) => fetchMerchflowsReviews(queryParams, signal),
    placeholderData: keepPreviousData,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
